import { times } from 'lodash';

function createAutomarkerTargets() {
    return {
        /** @type {string[] | null} */
        primary_targets: null,
        /** @type {string[] | null} */
        secondary_targets: null,
    };
}

function createSpeakingStandardFields() {
    return {
        audio_id: null,
        backups: times(3, () => ({
            delay: 6000,
            audio_id: null,
        })),

        ...createAutomarkerTargets(),
    };
}

export function createSpeakingMultiSelectItem() {
    return {
        ...createSpeakingStandardFields(),

        /** @type {'MULTI_SELECT'}*/
        item_type: 'MULTI_SELECT',
        answers: times(3, () => ({
            image_id: ''
        })),
    };
}

export function createSpeakingSimpleItem() {
    return {
        ...createSpeakingStandardFields(),
        item_type: 'SIMPLE',
    };
}

export function createSpeakingAdditionalImageItem() {
    return {
        ...createSpeakingStandardFields(),

        item_type: 'ADDITIONAL_IMAGE',
        answers: [{ image_id: '' }],
    };
}

export function createSpeakingHighlightItem() {
    return {
        ...createSpeakingStandardFields(),

        item_type: 'HIGHLIGHT',
        answers: [{
            image_id: '',
            coordinates: {
                top: 0,
                left: 0,
            },
        }],
    };
}

export function createSpeakingPlacementItem() {
    return {
        ...createSpeakingStandardFields(),

        item_type: 'PLACEMENT',
        answers: times(3, () => ({
            image_id: '',
            placement_image_id: '',
            coordinates: {
                top: 0,
                left: 0,
            },
        })),
    };
}

export function createSpeakingMessageItem() {
    return {
        ...createSpeakingStandardFields(),

        item_type: 'MESSAGE',
        answers: [{
            image_id: '',
            coordinates: {
                top: 0,
                left: 0,
            },
        }],
    };
}

export function createSpeakingDifferenceItem() {
    return {
        ...createSpeakingStandardFields(),

        item_type: 'DIFFERENCE',
        answers: [{
            image_id: '',
            coordinates: {
                top: 0,
                left: 0,
            },
        }],
    };
}

export function createSpeakingStoryItem({ isExample = false, isSummary = false } = {}) {
    return {
        is_example: isExample,
        ...(!isSummary && { image_id: '' }),
        ...createSpeakingStandardFields(),

        item_type: 'STORY',
        answers: isSummary ? [] : times(5, () => ({
            label: '',
            image_id: ''
        })),
    };
}